<template>
  <div>
           <vue-headful
            title="Thank you - Girish Jewellers"
            description="Thank yosu, girish jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
            <section id="main">
                <div class="container"> 
                    <article class="content span12">
                <div class="title-box no-margin">
                <h1 class="title">Thank you !</h1>
                <p>Your order is placed successfully, we will contact you soon. Please find the your order details from following.</p><br>
                </div>
                <ul id="checkoutsteps" class="clearfix">
                    <li class="active">
                    
                    <div class="step-content">
                        <div class="col2-set clearfix">
                        <div class="col-1">
                          <h3 class="title">Order Details</h3>
                          <address>
                              <span class="pull-left"><strong>Order No.:</strong> #{{results.OrderDetails.id}}</span>
                              <span class="pull-right"><strong>Order Date:</strong> {{results.OrderDetails.order_date}}</span><br>
                              <strong>Client:</strong> {{results.OrderDetails.client_name}}<br>
                              <span class="pull-left"><strong>Phone:</strong> {{results.OrderDetails.client_phone}}</span>
                              <span class="pull-right"><strong>Email:</strong> {{results.OrderDetails.client_email}}</span><br>
                              <span class="pull-left"><strong>Order Status:</strong> {{results.OrderDetails.order_status}}</span>
                              <span class="pull-right"><strong>Payment Status:</strong> {{results.OrderDetails.payment_status}}</span><br>
                              <span class="pull-left"><strong>Pcs:</strong> {{CountTotalPcs()}}</span>
                              <span class="pull-right"><strong>Total Weight:</strong> {{CountTotalWeight()}}</span><br><br>

                              

                              <h3 class="title">Special Instructions</h3>
                              {{results.OrderDetails.specialize_instructions}}
                              
                              
                          </address>
                          <div class="clearfix"></div>  
                        </div>
                        <div class="col-2">

                            <h3 class="title">Ordered Items</h3>
                            <div class="table-box" style="height:200px;overflow-y: auto;">
                            <table id="shopping-cart-table" class="shopping-cart-table table table-bordered table-striped" style="padding:0 0 0 0;border-bottom-style:solid;border-bottom-size:1px;">
                            <thead>
                                <tr>
                            <th></th>
                            <th class="td-name" style="padding: 0 0 0 10px;vertical-align: middle;">Item</th>
                            <th class="td-qty">Pcs</th>
                                </tr>
                            </thead>
                            <tbody>
                            
                            
                              <tr v-if="results.Items.length<=0">
                                  <td colspan="3">No item found!</td>
                              </tr>
                                <tr v-for="result in results.Items" :key="result.id">
                            <td class="td-images">
                                <img :src="result.image_path" :alt="result.product_name"  :title="result.product_name" width="70" height="70">
                            </td>
                            <td class="td-name">
                                <h2 class="product-name">
                                {{result.product_name}} [{{result.category_name}}]
                                <br><strong>Weight:</strong> {{result.weight}}
                                <span v-if="result.size != ''"><br><strong>Size:</strong> {{result.size}}</span>
                                </h2>
                            </td>
                        
                            <td class="td-qty">
                              <span class="price">{{result.qty}}</span>
                            </td>
                                </tr>
                                                </tbody>
                            </table><!-- .shopping-cart-table -->
                        </div>

                            
                        </div>
                        </div>
                    </div>
                    </li>
                    </ul>


<div class="clearfix"></div>

                <ul id="checkoutsteps" class="clearfix">
                    <li class="active">
                    
                    <div class="step-content">
                        <div class="col2-set clearfix">

                        <div class="col-1">
                            <h3 class="title">Delivery Address</h3>
                           <address v-html="results.Delivery.address"></address>                           
                            
                            <!-- .checkout-login -->
                            <div class="clearfix"></div>
                        </div>
                        <div class="col-2">
                          <h3 class="title">Billing Address</h3>
                           <address v-html="results.Billing.address"></address>
                        </div>
                        </div>
                    </div>
                    </li>
                    </ul>
                    <div v-if="!isMobile()" class="buttons-box clearfix pull-right">
                      <button  type="button"  class="btn" v-on:click="submit" id="btnsubmit" name="btnsubmit">Continue Shopping!</button>
                    </div>
                    <div v-if="isMobile()" class="buttons-box clearfix">
                        <button  type="button"  class="btn" style="width:100%;margin-top:-70px" v-on:click="submit" id="btnsubmit" name="btnsubmit">Continue Shopping!</button>
                    </div>
                    <br><br><br><br>
                    </article>
                </div>
            </section>         
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile()"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import {mapGetters, mapActions} from "vuex";
import vueHeadful from 'vue-headful';

export default {
  name: 'Thankyou',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    Footer,
    FooterWeb
    },created(){
        this.getSession;
        this.getBillingAddress;
        this.getDeliveryAddress;
    },
    computed:mapGetters(["Session","OrderDetails"]),
    watch:{
        Session(newValue) {
          if(newValue.is_login){
              if(this.$route.query.oid)
              {
                this.getOrderDetails(this.$route.query.oid);
              }else
              {
                Common.showError("Order referance is not avaiable!");
              }
            }
          else{
              this.$router.push('/login/?f=checkout')
            } 
          },
        OrderDetails(newValue) {this.get_response(newValue); },
    },
    mounted:function(){
      this.loadOnMount();
    },
    data:function(){
        return {results: { 
                           OrderDetails:{"id":"","order_date":"", "order_status":"", "tracking_no":"", "gross_amount":"", "payment_status":"", "sub_total":"", "tran_id":"", "discount_amt":"", "discount_code":"", "gross_total":"", "shipping_charges":"", "currency_mode":"", "client_name":"", "user_id":"", "specialize_instructions":"" },
                           Client:{"id":"","client_name":"", "client_phone":"", "client_email":"" },
                           Billing:{"address":""},
                           Delivery:{"address":""},
                           Items:[{"id":"", "product_name":"", "item_details":"", "qty":"", "price":"", "amount":"", "total_amount":"", "product_discount":"", "net_amount":"" }]
                         } };
    },
    methods:{
      ...mapActions(["getSession","getOrderDetails"]),
      isMobile:function(){
   return Common.isMobile();
},CountTotalWeight:function()
        {
          var total_weight = 0;
          if(this.results.Items.length > 0){
                this.results.Items.forEach((item) => {
                   total_weight = parseFloat(total_weight) + parseFloat(item.weight);
                });
          }
          return total_weight;
        },CountTotalPcs:function()
        {
          var total_pcs = 0;
          
          if(this.results.Items.length > 0){
                this.results.Items.forEach((item) => {
                   total_pcs = parseFloat(total_pcs) + parseFloat(item.qty);
                });
          }
          return total_pcs;
        },
get_response:function(response)
{ 
    //var rdata = JSON.parse(response);
    this.results = response;
    var items = ""; 
  var idx = 1;
  items = this.results.Items.map(function (b) { 
    var item = "\n*"+ idx.toString() +".) " + b.product_name + "*";
    item += "\n Pcs: " + b.qty
    item += "\n Weight: " + b.weight
    if(b.size != "")
    {
      item += "\n Size: " + b.size
    }
    item += "\n ------------------------------\n";
    idx++;
    return item;
  }).join();

    var Order = "*New Order Received*";
    Order += "\nOrder No: *#" + this.results.OrderDetails.id + "*";
    Order += "\nDate: " + this.results.OrderDetails.order_date;
    //Order += "\nTotal: ₹ " + this.results.OrderDetails.gross_total;
    Order += "\nFrom: *" + this.results.OrderDetails.client_name + "*";
    Order += "\nPcs: *" + this.CountTotalPcs() + "*";
    Order += "\nGross Weight: *" + this.CountTotalWeight() + "*";
    Order += "\n\n *Items are following: * \n" + items;
    Order += "\nDeliver To: " + Common.replaceAll(Common.replaceAll(Common.replaceAll(this.results.Delivery.address,"<br>","\n"),"<strong>",""),"</strong>","");
    Order += "\n--------------------\nView order: https://www.girishjewellers.com/site/admin/order-view/?oid=" + this.results.OrderDetails.id;
    Order += "\n--------------------\nThank you\n\n From :- Girish Jewellers Application\nWebsite: https://www.girishjewellers.com";

    //console.log(Order);
    //location.href = "https://wa.me/912812229302?text=" + encodeURIComponent(Order);
    if(Common.WAOrderText != this.results.OrderDetails.id)
    {
      Common.WAOrderText = this.results.OrderDetails.id
      window.open("https://wa.me/912812229302?text="+ encodeURIComponent(Order));
    }

},
submit: function()
{
   
    //this.updateDeliveryAddress(this.results.Delivery);
    //this.updateBillingAddress(this.results.Billing);

    this.$router.push("/home");

    //Common.callServerFunction("Users/UserController::Login",this.get_submit_response,this.results,"Users");
      
    //Common.showValidation(["Name required.","Address required.","Surname required."]);        
      },onResize: function() {
    },
loadOnMount: function() {
      
      Common.stopAjaxLoader();
      this.getSession();
      $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
        });
    }

  }
    
}
</script>